export default {
  alternativeDispoContainer: {
    padding: '10px 0 10px 0',
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    width: 'calc(100% - 40px)',
    '@media (min-width: 801px)': {
      //width: '100%',
      padding: '0 10px 10px 0',
      boxSizing: 'border-box',
      maxWidth: '1170px',
      margin: '0 auto',
      marginTop: '50px'
    }
  },
  slideContainer: {
    '& .nestedMultiContent': {
      display: 'flex',
      transition: 'margin-left 0.5s ease',
    },
    '& .nestedMultiContent > *:last-child': {
      marginRight: '2px',
    },
    '& .nestedMultiContent > *:not(:last-child)': {
      marginRight: '45px',
    },
    '@media(min-width: 901px)': {
      '.nestedMultiContent > *:not(:last-child)': {
        marginRight: '50px',
      }
    },
    '& .wrapperMultiContent': {
      width: '100%',
      overflow: 'hidden',
      paddingBottom: '10px',

    },
    '@media (min-width: 801px)': {
      width: 'calc(100% - 40px)',
      margin: '10px auto 0',
    },
    maxWidth: '1170px',
    margin: '0 auto 0',
    position: 'relative',

    '& $topButton': {
      height: '483px',
      display: 'flex',
      justifyContent: 'center',
      top: '0%',
      right: '-35px',
      '& > button': {
        width: '100%',
        position: 'relative',
        left: '5px'
      }
    },

    '& $botButton': {
      height: '483px',
      display: 'flex',
      justifyContent: 'center',
      top: '0%',
      left: '-35px',
      '& > button': {
        width: '100%',
        position: 'relative',
        right: '5px'
      }
    },
  },
  topButton: {
    width: '40px',
    height: '40px',
    bottom: '100%',
    position: 'absolute',
    right: '0',
    borderBottom: '1px solid #fff',
    borderBottomColor: 'rgba(255,255,255,0.6)',
    top: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '11px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    },
    '&.disabled' : {
      opacity: '0.3',
      pointerEvents: 'none'
    }
  },
  botButton: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    right: '0',
    bottom: '100%',
    left: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '11px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    },
    '&.disabled' : {
      opacity: '0.3',
      pointerEvents: 'none'
    }
  },
  disabledButton: {
    display: 'none !important',
    //opacity: '0.3 !important',
    //pointerEvents: 'none !important'
  },
  removePadding: {
    padding: '0'
  },
};
